import { questionTypes } from 'sharedParts';
import * as keysBlockStyling from '../../const/keysBlockStyling';
import stylingSelectors from '../../selectors';

const buttonConfig = {
  [keysBlockStyling.KEY_BUTTON_BACKGROUND_COLOR_KEY]:
    stylingSelectors.getStylingButtonBackgroundColor,
  [keysBlockStyling.KEY_BUTTON_BORDER_COLOR_KEY]:
    stylingSelectors.getStylingButtonBorderColor,
  [keysBlockStyling.KEY_BUTTON_BORDER_RADIUS_KEY]:
    stylingSelectors.getStylingButtonBorderRadius,
  [keysBlockStyling.KEY_BUTTON_BORDER_STYLE_KEY]:
    stylingSelectors.getStylingButtonBorderStyle,
  [keysBlockStyling.KEY_BUTTON_BORDER_WIDTH_KEY]:
    stylingSelectors.getStylingButtonBorderWidth,
  [keysBlockStyling.KEY_BUTTON_FONT_COLOR_KEY]:
    stylingSelectors.getStylingButtonFontColor,
  [keysBlockStyling.KEY_BUTTON_FONT_SIZE_KEY]:
    stylingSelectors.getStylingButtonFontSize,
  [keysBlockStyling.KEY_BUTTON_FONT_STYLE_KEY]:
    stylingSelectors.getStylingButtonFontStyle,
  [keysBlockStyling.KEY_BUTTON_FONT_WEIGHT_KEY]:
    stylingSelectors.getStylingButtonFontWeight,
  [keysBlockStyling.KEY_BUTTON_TEXT_DECORATION_KEY]:
    stylingSelectors.getStylingButtonTextDecoration,
  [keysBlockStyling.KEY_BUTTON_TEXT_TRANSFORM_KEY]:
    stylingSelectors.getStylingButtonTextTransform,
};

const nextButtonSelectors = buttonConfig;
const submitButtonSelectors = buttonConfig;
const redirectButtonSelectors = buttonConfig;
const headerImageSelectors = {};

const labelSelectors = {
  [keysBlockStyling.KEY_LABEL_FONT_COLOR]:
    stylingSelectors.getStylingLabelFontColor,
  [keysBlockStyling.KEY_LABEL_FONT_SIZE]:
    stylingSelectors.getStylingLabelFontSize,
  [keysBlockStyling.KEY_LABEL_FONT_STYLE]:
    stylingSelectors.getStylingLabelFontStyle,
  [keysBlockStyling.KEY_LABEL_FONT_WEIGHT]:
    stylingSelectors.getStylingLabelFontWeight,
  [keysBlockStyling.KEY_LABEL_STICK_TO]:
    stylingSelectors.getStylingLabelStickTo,
  [keysBlockStyling.KEY_LABEL_TEXT_DECORATION]:
    stylingSelectors.getStylingLabelTextDecoration,
  [keysBlockStyling.KEY_LABEL_TEXT_TRANSFORM]:
    stylingSelectors.getStylingLabelTextTransform,
};

const textfieldSelectors = {
  [keysBlockStyling.KEY_TEXTFIELD_BACKGROUND_COLOR]:
    stylingSelectors.getStylingTextfieldBackgroundColor,
  [keysBlockStyling.KEY_TEXTFIELD_BORDER_COLOR]:
    stylingSelectors.getStylingTextfieldBorderColor,
  [keysBlockStyling.KEY_TEXTFIELD_BORDER_RADIUS]:
    stylingSelectors.getStylingTextfieldBorderRadius,
  [keysBlockStyling.KEY_TEXTFIELD_BORDER_STYLE]:
    stylingSelectors.getStylingTextfieldBorderStyle,
  [keysBlockStyling.KEY_TEXTFIELD_BORDER_WIDTH]:
    stylingSelectors.getStylingTextfieldBorderWidth,
  [keysBlockStyling.KEY_TEXTFIELD_FONT_COLOR]:
    stylingSelectors.getStylingTextfieldFontColor,
  [keysBlockStyling.KEY_TEXTFIELD_FONT_SIZE]:
    stylingSelectors.getStylingTextfieldFontSize,
  [keysBlockStyling.KEY_TEXTFIELD_FONT_STYLE]:
    stylingSelectors.getStylingTextfieldFontStyle,
  [keysBlockStyling.KEY_TEXTFIELD_FONT_WEIGHT]:
    stylingSelectors.getStylingTextfieldFontWeight,
  [keysBlockStyling.KEY_TEXTFIELD_TEXT_DECORATION]:
    stylingSelectors.getStylingTextfieldTextDecoration,
  [keysBlockStyling.KEY_TEXTFIELD_TEXT_TRANSFORM]:
    stylingSelectors.getStylingTextfieldTextTransform,
};

export const textOptionSelectors = {
  [keysBlockStyling.KEY_TEXT_OPTION_FONT_FAMILY]:
    stylingSelectors.getStylingOptionTextFontFamily,
  [keysBlockStyling.KEY_TEXT_OPTION_FONT_COLOR]:
    stylingSelectors.getStylingOptionTextFontColor,
  [keysBlockStyling.KEY_TEXT_OPTION_FONT_SIZE]:
    stylingSelectors.getStylingOptionTextFontSize,
  [keysBlockStyling.KEY_TEXT_OPTION_FONT_STYLE]:
    stylingSelectors.getStylingOptionTextFontStyle,
  [keysBlockStyling.KEY_TEXT_OPTION_FONT_WEIGHT]:
    stylingSelectors.getStylingOptionTextFontWeight,
  [keysBlockStyling.KEY_TEXT_OPTION_TEXT_DECORATION]:
    stylingSelectors.getStylingOptionTextDecoration,
  [keysBlockStyling.KEY_TEXT_OPTION_TEXT_TRANSFORM]:
    stylingSelectors.getStylingOptionTextTransform,
};

export const textQuestionSelectors = {
  [keysBlockStyling.KEY_TEXT_QUESTION_FONT_FAMILY]:
    stylingSelectors.getStylingQuestionTextFontFamily,
  [keysBlockStyling.KEY_TEXT_QUESTION_FONT_COLOR]:
    stylingSelectors.getStylingQuestionTextFontColor,
  [keysBlockStyling.KEY_TEXT_QUESTION_FONT_SIZE]:
    stylingSelectors.getStylingQuestionTextFontSize,
  [keysBlockStyling.KEY_TEXT_QUESTION_FONT_STYLE]:
    stylingSelectors.getStylingQuestionTextFontStyle,
  [keysBlockStyling.KEY_TEXT_QUESTION_FONT_WEIGHT]:
    stylingSelectors.getStylingQuestionTextFontWeight,
  [keysBlockStyling.KEY_TEXT_QUESTION_TEXT_DECORATION]:
    stylingSelectors.getStylingQuestionTextDecoration,
  [keysBlockStyling.KEY_TEXT_QUESTION_TEXT_TRANSFORM]:
    stylingSelectors.getStylingQuestionTextTransform,
};

const textStaticSelectors = {
  [keysBlockStyling.KEY_TEXT_STATIC_FONT_FAMILY]:
    stylingSelectors.getStylingStaticTextFontFamily,
  [keysBlockStyling.KEY_TEXT_STATIC_FONT_COLOR]:
    stylingSelectors.getStylingStaticTextFontColor,
  [keysBlockStyling.KEY_TEXT_STATIC_FONT_SIZE]:
    stylingSelectors.getStylingStaticTextFontSize,
  [keysBlockStyling.KEY_TEXT_STATIC_FONT_STYLE]:
    stylingSelectors.getStylingStaticTextFontStyle,
  [keysBlockStyling.KEY_TEXT_STATIC_FONT_WEIGHT]:
    stylingSelectors.getStylingStaticTextFontWeight,
  [keysBlockStyling.KEY_TEXT_STATIC_TEXT_DECORATION]:
    stylingSelectors.getStylingStaticTextDecoration,
  [keysBlockStyling.KEY_TEXT_STATIC_TEXT_TRANSFORM]:
    stylingSelectors.getStylingStaticTextTransform,
};

const longTextSelectors = {
  ...labelSelectors,
  ...textfieldSelectors,
  ...textQuestionSelectors,
};
const questionDropdownSelectors = {
  ...labelSelectors,
  ...textfieldSelectors,
  ...textOptionSelectors,
  ...textQuestionSelectors,
};
const questionImageMultiSelectors = {
  [keysBlockStyling.KEY_SELECTION_COLOR]:
    stylingSelectors.getStylingSelectionColor,
  ...labelSelectors,
  ...textfieldSelectors,
  ...textOptionSelectors,
  ...textQuestionSelectors,
};
const questionImageSingleSelectors = {
  [keysBlockStyling.KEY_SELECTION_COLOR]:
    stylingSelectors.getStylingSelectionColor,
  ...labelSelectors,
  ...textfieldSelectors,
  ...textOptionSelectors,
  ...textQuestionSelectors,
};
const questionMatrixMultiSelectors = {
  [keysBlockStyling.KEY_SELECTION_COLOR]:
    stylingSelectors.getStylingSelectionColor,
  ...labelSelectors,
  ...textfieldSelectors,
  ...textOptionSelectors,
  ...textQuestionSelectors,
};
const questionMatrixRadioSelectors = {
  [keysBlockStyling.KEY_SELECTION_COLOR]:
    stylingSelectors.getStylingSelectionColor,
  ...labelSelectors,
  ...textfieldSelectors,
  ...textOptionSelectors,
  ...textQuestionSelectors,
};
const questionMatrixScaleSelectors = {
  [keysBlockStyling.KEY_SELECTION_COLOR]:
    stylingSelectors.getStylingSelectionColor,
  ...labelSelectors,
  ...textfieldSelectors,
  ...textOptionSelectors,
  ...textQuestionSelectors,
};
const questionMultiSelectors = {
  [keysBlockStyling.KEY_SELECTION_COLOR]:
    stylingSelectors.getStylingSelectionColor,
  ...labelSelectors,
  ...textfieldSelectors,
  ...textOptionSelectors,
  ...textQuestionSelectors,
};
const questionNumericSelectors = {
  [keysBlockStyling.KEY_SELECTION_COLOR]:
    stylingSelectors.getStylingSelectionColor,
  ...labelSelectors,
  ...textfieldSelectors,
  ...textQuestionSelectors,
};
const questionScaleSelectors = {
  [keysBlockStyling.KEY_SELECTION_COLOR]:
    stylingSelectors.getStylingSelectionColor,
  ...labelSelectors,
  ...textfieldSelectors,
  ...textQuestionSelectors,
};
const questionSingleSelectors = {
  [keysBlockStyling.KEY_SELECTION_COLOR]:
    stylingSelectors.getStylingSelectionColor,
  ...labelSelectors,
  ...textfieldSelectors,
  ...textOptionSelectors,
  ...textQuestionSelectors,
};
const respondentBlankFieldSelectors = {
  ...labelSelectors,
  ...textfieldSelectors,
};
const respondentCompanyNameSelectors = {
  ...labelSelectors,
  ...textfieldSelectors,
};
const respondentFirstNameSelectors = {
  ...labelSelectors,
  ...textfieldSelectors,
};
const respondentInfoDropdownSelectors = {
  ...labelSelectors,
  ...textOptionSelectors,
  ...textQuestionSelectors,
};
const respondentInfoLongTextSelectors = {
  ...labelSelectors,
  ...textfieldSelectors,
  ...textQuestionSelectors,
};
const respondentInfoMultiSelectors = {
  [keysBlockStyling.KEY_SELECTION_COLOR]:
    stylingSelectors.getStylingSelectionColor,
  ...textOptionSelectors,
  ...textQuestionSelectors,
};
const respondentInfoRadioSelectors = {
  [keysBlockStyling.KEY_SELECTION_COLOR]:
    stylingSelectors.getStylingSelectionColor,
  ...textOptionSelectors,
  ...textQuestionSelectors,
};
const respondentInfoShortTextSelectors = {
  ...labelSelectors,
  ...textfieldSelectors,
  ...textQuestionSelectors,
};
const respondentLastNameSelectors = {
  ...labelSelectors,
  ...textfieldSelectors,
};
const respondentMailSelectors = {
  ...labelSelectors,
  ...textfieldSelectors,
};
const respondentPhoneSelectors = {
  ...labelSelectors,
  ...textfieldSelectors,
};
const shortTextSelectors = {
  ...labelSelectors,
  ...textfieldSelectors,
  ...textQuestionSelectors,
};
const socialFollowSelectors = {
  ...labelSelectors,
};
const staticTextSelectors = {
  ...textStaticSelectors,
};

const blockStylingSelectors = {
  [questionTypes.headerImage]: headerImageSelectors,
  [questionTypes.longText]: longTextSelectors,
  [questionTypes.questionDropdown]: questionDropdownSelectors,
  [questionTypes.questionImageMulti]: questionImageMultiSelectors,
  [questionTypes.questionImageSingle]: questionImageSingleSelectors,
  [questionTypes.questionMatrixMulti]: questionMatrixMultiSelectors,
  [questionTypes.questionMatrixRadio]: questionMatrixRadioSelectors,
  [questionTypes.questionMatrixScale]: questionMatrixScaleSelectors,
  [questionTypes.questionMulti]: questionMultiSelectors,
  [questionTypes.questionNumeric]: questionNumericSelectors,
  [questionTypes.questionScale]: questionScaleSelectors,
  [questionTypes.questionSingle]: questionSingleSelectors,
  [questionTypes.redirectButton]: redirectButtonSelectors,
  [questionTypes.respondentBlankField]: respondentBlankFieldSelectors,
  [questionTypes.respondentCompanyName]: respondentCompanyNameSelectors,
  [questionTypes.respondentFirstName]: respondentFirstNameSelectors,
  [questionTypes.respondentInfoDropdown]: respondentInfoDropdownSelectors,
  [questionTypes.respondentInfoLongText]: respondentInfoLongTextSelectors,
  [questionTypes.respondentInfoMulti]: respondentInfoMultiSelectors,
  [questionTypes.respondentInfoRadio]: respondentInfoRadioSelectors,
  [questionTypes.respondentInfoShortText]: respondentInfoShortTextSelectors,
  [questionTypes.respondentLastName]: respondentLastNameSelectors,
  [questionTypes.respondentMail]: respondentMailSelectors,
  [questionTypes.respondentPhone]: respondentPhoneSelectors,
  [questionTypes.shortText]: shortTextSelectors,
  [questionTypes.socialFollow]: socialFollowSelectors,
  [questionTypes.staticText]: staticTextSelectors,
  [questionTypes.nextButton]: nextButtonSelectors,
  [questionTypes.submitButton]: submitButtonSelectors,
};

export default blockStylingSelectors;
